import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  xFieldOptionsSelector,
  yFieldOptionsSelector,
  zFieldOptionsSelector
} from 'redux/schemaSlice';
import {
  xFieldSet,
  yFieldSet,
  zFieldSet,
  xFieldSelector,
  yFieldSelector,
  zFieldSelector
} from 'redux/keyFieldsSlice';

import { FormControl, StyledCalciteLabel } from 'components/StyledComponents';

import Select from 'components/Select';
import SpatialReference from 'components/LocationSettings/SpatialReference';

import { CalciteOption } from 'components/Calcite';

const XyFields: React.FC = () => {
  const dispatch = useDispatch();

  const xFieldOptions = useSelector(xFieldOptionsSelector);
  const yFieldOptions = useSelector(yFieldOptionsSelector);
  const zFieldOptions = useSelector(zFieldOptionsSelector);
  const xField = useSelector(xFieldSelector);
  const yField = useSelector(yFieldSelector);
  const zField = useSelector(zFieldSelector);

  return (
    <>
      <FormControl horizontal>
        <StyledCalciteLabel>X (longitude)</StyledCalciteLabel>
        <Select
          label="Longitude"
          value={xField}
          onChange={value => dispatch(xFieldSet(value as string))}
          options={xFieldOptions.map(({ fieldName, displayName }) => (
            <CalciteOption
              key={fieldName}
              selected={xField === fieldName}
              value={fieldName}
            >
              {displayName}
            </CalciteOption>
          ))}
        />
      </FormControl>
      <FormControl horizontal>
        <StyledCalciteLabel>Y (latitude)</StyledCalciteLabel>
        <Select
          label="Latitude"
          value={yField}
          onChange={value => dispatch(yFieldSet(value as string))}
          options={yFieldOptions.map(({ fieldName, displayName }) => (
            <CalciteOption
              key={fieldName}
              selected={yField === fieldName}
              value={fieldName}
            >
              {displayName}
            </CalciteOption>
          ))}
        />
      </FormControl>
      <FormControl horizontal>
        <StyledCalciteLabel>Z (altitude)</StyledCalciteLabel>
        <Select
          label="Altitude"
          value={zField}
          onChange={value => dispatch(zFieldSet(value as string))}
          options={zFieldOptions.map(({ fieldName, displayName }) => (
            <CalciteOption
              key={fieldName}
              selected={zField === fieldName}
              value={fieldName}
            >
              {displayName}
            </CalciteOption>
          ))}
        />
      </FormControl>
      <SpatialReference />
    </>
  );
};

export default XyFields;
